import type { QueryClient } from "@tanstack/react-query";
import { configureApiClient } from "@teamna/web-client/api/client.ts";
import { setVersionCheckBase } from "@teamna/ui/lib/version-check.ts";
import { actAsHeaders } from "./act-as.ts";
import { ccKeys } from "./cc-api.ts";

/**
 * Points the shared pieces at Control Center: every Desk hook calls `/v1/desk/...` with
 * `X-Act-As-Business` and the session cookie, and the build check reads `/version.json`.
 * Called once by `main.tsx`, and by tests before they render.
 */
export function configureControlCenter(): void {
  configureApiClient({ basePath: "/v1/desk", headers: actAsHeaders, credentials: "include" });
  setVersionCheckBase("/");
}

/**
 * A 401 from anywhere: the staff session ended. Everything read with it is dropped except the
 * failed `GET /v1/me`, which the sign-in page reads to know it should show the button (clearing it
 * too would refetch it, get another 401, and loop), and the page goes to sign-in.
 */
export function onSessionEnded(
  queryClient: QueryClient,
  router: { state: { location: { pathname: string } }; navigate: (options: { to: "/sign-in" }) => Promise<void> },
): void {
  queryClient.removeQueries({ predicate: (query) => query.queryKey.join("/") !== ccKeys.me.join("/") });
  if (router.state.location.pathname !== "/sign-in") void router.navigate({ to: "/sign-in" });
}
